var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOurBenefit4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_18874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 38.5716C30.2569 38.5716 38.5716 30.2569 38.5716 20.0001C38.5716 9.74342 30.2569 1.42871 20.0001 1.42871C9.74342 1.42871 1.42871 9.74342 1.42871 20.0001C1.42871 30.2569 9.74342 38.5716 20.0001 38.5716Z",
    stroke: "#00CC61",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12.8574V20.0003L27.2571 28.4574",
    stroke: "#00CC61",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_18874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOurBenefit4);
export default __webpack_public_path__ + "static/media/icon-our-benefit-4.cb3b2b19eda7087017e3e3bef2d6da03.svg";
export { ForwardRef as ReactComponent };